import { Arrow, cn } from "@jog/react-components";
export const ArrowText = ({ children, className, ...props }) => (<div className={cn("flex cursor-pointer items-center text-sm", className)} {...props}>
        <Arrow className="mb-1 !border-gray-darker"/>
        <div className="ml-2.5">{children}</div>
    </div>);
